<a class="skip-link visually-hidden-focusable"
   [attr.href]="'#' + targetId"
   (click)="skipToContent($event)">{{ 'a11y.skip_to_content' | translate }}</a>
